export default __webpack_public_path__ + "static/media/04.a02b343a.jpg";